<div class="payment-page">
  <div class="payment-page__body">
    <div class="payment-page__amount">
      <span>Montant à payer</span>
      <strong>{{ summaryAmountLabel }}</strong>
    </div>

    <div class="payment-page__state" *ngIf="loadingProviders">
      <mat-spinner diameter="36"></mat-spinner>
      <p>Chargement des opérateurs…</p>
    </div>

    <p class="payment-page__state" *ngIf="loadError && !loadingProviders">
      Impossible d’afficher les opérateurs.
    </p>

    <ng-container *ngIf="!loadingProviders && !loadError">
      <h2 class="payment-page__section-title">Choisissez votre opérateur</h2>

      <div class="payment-providers">
        <button
          type="button"
          class="payment-provider"
          *ngFor="let provider of providers"
          [class.payment-provider--selected]="isSelected(provider)"
          (click)="selectProvider(provider)"
        >
          <span
            class="payment-provider__logo"
            [ngClass]="{
              'payment-provider__logo--image': !!providerLogoUrl(provider),
              'payment-provider__logo--orange': providerBrandClass(provider) === 'payment-provider__logo--orange',
              'payment-provider__logo--mtn': providerBrandClass(provider) === 'payment-provider__logo--mtn'
            }"
          >
            <img
              *ngIf="providerLogoUrl(provider) as logoUrl"
              [src]="logoUrl"
              [alt]="provider.name"
            />
            <span *ngIf="!providerLogoUrl(provider)" class="payment-provider__logo-fallback">
              {{ providerInitials(provider) }}
            </span>
          </span>

          <span class="payment-provider__content">
            <strong>{{ providerDisplayName(provider) }}</strong>
            <small>{{ providerDescription(provider) }}</small>
          </span>

          <span class="payment-provider__check" *ngIf="isSelected(provider)" aria-hidden="true">
            <mat-icon>check</mat-icon>
          </span>
          <mat-icon class="payment-provider__chevron" *ngIf="!isSelected(provider)">chevron_right</mat-icon>
        </button>
      </div>

      <ng-container *ngIf="selectedProvider">
        <div class="payment-page__security">
          <mat-icon>shield</mat-icon>
          <p>Vos informations sont 100% sécurisées et ne seront jamais partagées.</p>
        </div>

        <form class="payment-page__form" [formGroup]="form" (ngSubmit)="submitPayment()">
          <div class="payment-page__fields-row">
            <label class="payment-field payment-field--amount">
              <span>Montant à payer</span>
              <input type="text" [value]="displayAmount" readonly />
            </label>

            <label class="payment-field payment-field--currency" *ngIf="currencyOptions.length">
              <span class="payment-field__hidden-label">Devise</span>
              <select (change)="onCurrencyChange($any($event.target).value)">
                <option
                  *ngFor="let option of currencyOptions"
                  [value]="option.id"
                  [selected]="option.id === selectedCurrencyId">
                  {{ option.label }}
                </option>
              </select>
            </label>
          </div>

          <div class="payment-field payment-field--phone">
            <span>Téléphone</span>
            <app-phone-input
              formControlName="phoneNumber"
              inputId="subscription-payment-phone"
              [invalid]="!!(form.controls.phoneNumber.touched && form.controls.phoneNumber.invalid)"
            ></app-phone-input>
          </div>

          <p class="payment-page__pending" *ngIf="pendingMessage">{{ pendingMessage }}</p>

          <button type="submit" class="btn btn--primary payment-page__submit" [disabled]="!canPay">
            {{ paying ? 'Paiement en cours…' : 'Payer' }}
          </button>
        </form>
      </ng-container>
    </ng-container>
  </div>
</div>

<app-error-info-modal
  [open]="!!errorModalMessage"
  [message]="errorModalMessage || ''"
  [showRetry]="errorModalCanRetry"
  (closed)="closeErrorModal()"
  (retried)="retryErrorModal()">
</app-error-info-modal>
